import Model from './Model'

export default class TenantModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'tenants'
  }
}
